<template>
<div id="timesheet-view">
  <timesheet-view-sidebar
    :isSidebarActive="addNewDataSidebar"
    @closeSidebar="toggleDataSidebar"
    :data="sidebarData"
    :locations="locations"
    :destinations="destinations"
    :equipments="equipments"
    :employees="employees"
    :muckTypes="muckTypes"
    :projectId="selectedProjectId"
    :initialDate="selectedDateTime"
    :materialSubTypes="materialSubTypes"
    @onTimesheetUpdated="timesheetUpdated"
    @onTimesheetInserted="timesheetInserted"
    @onRefreshTimesheets="refreshTimesheets"
  />
  <vx-card ref="listCard" :title="$t('GradeControl.Timesheet.TimesheetList')  + ' - ' + selectedDate"  class="timesheet-list-filters mb-8" title-color="black" refresh-content-action @refresh="getTimesheetEntries" >
    <vs-row vs-type="flex" vs-justify="space-between">
      <vs-col  vs-type="flex" vs-justify="flex-start" vs-align="center" vs-lg="2" vs-sm="2" vs-xs="12" class="m-3" >
        <datepicker format="yyyy-MM-dd" 
          placeholder="Select Date" 
          v-model="selectedDateTime"
          :highlighted="highlighted"></datepicker>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="3" vs-sm="2" vs-xs="12" class="m-3">
          <vs-checkbox v-model="showDeleted">{{$t('GradeControl.Timesheet.ShowDeleted')}}</vs-checkbox>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="12" class="m-3" >
        <vx-tooltip :text="$t('Print')" position="bottom" delay=".3s">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <feather-icon icon="PrinterIcon" class="cursor-pointer ml-5" svg-classes="h-6 w-6" />
            <vs-dropdown-menu>
              <vs-dropdown-item @click="openTimesheetReport">
                <span class="flex items-center">
                  <feather-icon icon="ClockIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>{{$t('GradeControl.Reports.Timesheet')}}</span>
                </span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="openMuckReport">
                <span class="flex items-center">
                  <feather-icon icon="TruckIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>{{$t('GradeControl.Reports.Muck')}}</span>
                </span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
         </vx-tooltip>
        <vx-tooltip :text="$t('AddNew')" position="bottom" delay=".3s">
           <feather-icon icon="PlusCircleIcon" class="cursor-pointer ml-5" svg-classes="h-6 w-6" @click="addNewData" />
        </vx-tooltip>
        <vx-tooltip :text="$t('Import')" position="bottom" delay=".3s">
          <feather-icon icon="CheckCircleIcon" class="cursor-pointer ml-5" svg-classes="h-6 w-6" @click="openImportConfirm" />
        </vx-tooltip>
        <vx-tooltip :text="$t('Delete')" position="bottom" delay=".3s">
          <feather-icon icon="TrashIcon" class="cursor-pointer ml-5" svg-classes="h-6 w-6" @click="openDeleteConfirm" />
        </vx-tooltip>
        <vx-tooltip :text="$t('CancelImport')" position="bottom" delay=".3s">
          <feather-icon icon="XCircleIcon" class="cursor-pointer ml-5" svg-classes="h-6 w-6" @click="openCancelImportConfirm" />
        </vx-tooltip>
      </vs-col>
    </vs-row>
    <ag-grid-vue
      ref="agGridTable"
      :components="components"
      :frameworkComponents="frameworkComponents"
      :gridOptions="gridOptions"
      :context="context"
      :key="tableKey"
      class="ag-theme-material w-100 my-4 ag-grid-table"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      :rowClassRules="rowClassRules"
      :rowData="timesheetList"
      rowSelection="multiple"
      colResizeDefault="shift"
      :animateRows="true"
      :pagination="false"
      :suppressPaginationPanel="true"
      :enableRtl="$vs.rtl">
    </ag-grid-vue>

    <SummaryTable
      class="summaryTable"
      :data="timesheetSummary"
    />
    
  </vx-card>
  <vs-popup class="holamundo" :title="$t('GradeControl.Timesheet.Importation.ResultTitle')" :active.sync="importationPopupActive">
    <vs-list>
      <div v-for="result in importationResults" class="mb-3" :key="result.description">

        <vs-list-header v-if="result.isSuccess" icon-pack="feather" icon="icon-clock" :title="result.description" color="success" />
        <vs-list-header v-else icon-pack="feather" icon="icon-clock" :title="result.description" color="danger" />
        <div v-for="message in result.messages" :key="message">
          <vs-list-item icon-pack="feather" icon="icon-alert-circle" :title="message"></vs-list-item>
        </div>
      </div>
    </vs-list>
  </vs-popup>
  <vs-popup class="holamundo" :title="$t('GradeControl.Timesheet.AddNewLocation')" :active.sync="locationPopupActive">
    <add-location style="height:250px;"
      :projectId="selectedProjectId"
      @onCancel="locationCancelled"
      @onLocationInserted="locationInserted"
    />
  </vs-popup>
  <vs-popup class="holamundo" :title="$t('GradeControl.Timesheet.Versions')" :active.sync="versionPopupActive">
    <timesheet-version style="width:750px;"
      :timesheetId="versionTimesheetId"
      @onClosed="versionClosed"
    />
  </vs-popup>
  <vs-popup class="holamundo" :title="$t('GradeControl.Timesheet.Comments')" :active.sync="commentPopupActive">
    <timesheet-comments 
    :timesheet="selectedTimesheet"
    @onCancel="cancelComments"
    @onSaved="saveComments">
    </timesheet-comments>
  </vs-popup>
</div>

</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";

import Vue from "vue";
import moment from 'moment'

import moduleGradeControl from "@/store/geo/gradecontrol/moduleGradeControl.js";

import TimesheetViewSidebar from "./components/timesheetSideView";
import Datepicker from 'vuejs-datepicker';
import ShiftEnum from './../../../shared/ShiftEnum.js';
import LocationCellRenderer from './../components/LocationCellRenderer.vue'
import DestinationCellRenderer from './components/DestinationCellRenderer.vue'
import MaterialTypeCellRenderer from './../components/MaterialTypeCellRenderer.vue'
import TimesheetActionsCellRenderer from './components/TimesheetActionsCellRenderer.vue'
import LocationCodeCellEditor from './components/LocationCodeCellEditor.vue'
import DestinationCellEditor from './components/DestinationCellEditor.vue'
import TimesheetOperationTypeCellEditor from './components/TimesheetOperationTypeCellEditor.vue'
import TimesheetOperationTypeCellRenderer from './components/TimesheetOperationTypeCellRenderer.vue'
import EquipmentCodeCellEditor from './components/EquipmentCodeCellEditor.vue'
import EmployeesCellEditor from './components/EmployeesCellEditor.vue'
import SampleRangeCellRenderer from './components/SampleRangeCellRenderer.vue'
import EmployeeCellRenderer from './components/EmployeeCellRenderer.vue'
import EquipmentCellRenderer from './components/EquipementCellRenderer.vue'
import MaterialTypeCellEditor from '../components/MaterialTypeCellEditor.vue';
import MuckTypeCellEditor from './components/MuckTypeCellEditor.vue';
import booleanCellRenderer from './../../../shared/components/cell-formators/boolean-cell.vue';
import AddLocation from './components/AddLocation.vue';
import TimesheetVersion from './components/timesheetVersion.vue';
import TimesheetComments from './components/timesheetComments.vue';
import TimesheetOperationTypeEnum from "../TimesheetOperationTypeEnum";
import EquipmentTypeEnum from "../EquipmentTypeEnum";

import SummaryTable from "./components/SummaryTable.vue";

export default {
  components: {
    /* eslint-disable vue/no-unused-components */
    AgGridVue,
    Datepicker,
    TimesheetViewSidebar,
    TimesheetActionsCellRenderer,
    LocationCodeCellEditor,
    DestinationCellEditor,
    TimesheetOperationTypeCellEditor,
    TimesheetOperationTypeCellRenderer,
    EmployeesCellEditor,
    EquipmentCodeCellEditor,
    LocationCellRenderer,
    DestinationCellRenderer,
    SampleRangeCellRenderer,
    EmployeeCellRenderer,
    EquipmentCellRenderer,
    MaterialTypeCellEditor,
    MaterialTypeCellRenderer,
    booleanCellRenderer,
    AddLocation,
    TimesheetVersion,
    TimesheetComments,
    SummaryTable
  },
  data() {
    return {
      tableKey:0,
      selectedDateTime: null,
      selectedProjectId: null,
      selectedTimesheetsId: null,
      showDeleted: false,
      addNewDataSidebar: false,
      sidebarData: {},
      importationPopupActive: false,
      locations: [],
      locationPopupActive: false,
      versionTimesheetId: null,
      selectedTimesheet : null,
      selectedComments: "",
      selectedUserComments : "",
      versionPopupActive: false,
      commentPopupActive: false,
      importationResults: [],
      highlighted: {},
      dailySummary: null,
      newLocationCode:null,
      defaultColDef: {
        sortable: true,
        resizable: true,
        editable: (params) => {
          return params.data.timesheetImportationId === null
        }
      },
      gridApi: null,
      gridOptions: {
        onCellValueChanged: (params) => {
          this.updateTimesheetEntry(params.data);
        },
        getRowNodeId: (data) => {
          return data.timesheetStagingEntryId;
        },
        getRowId: (params) => {
          return params.data.timesheetStagingEntryId;
        }
      },
      context: { componentParent: this },
      rowClassRules: {
        'timesheet-approved': 'data.timesheetImportationId != null',
        'timesheet-modified': 'data.timesheetImportationId == null && data.modificationDate != null && !data.isDeleted',
        'timesheet-deleted': 'data.isDeleted'
      },
      columnDefs: [
        {
          headerName: 'Actions',
          field: 'sampleCount',
          width: 250,
          editable: false,
          sortable: false,
          filter: true,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          cellRendererFramework: Vue.extend(TimesheetActionsCellRenderer)
        },
        {
          headerName: this.$t('GradeControl.Timesheet.TimesheetOperationType'),
          field: "timesheetOperationType",
          filter: true,
          filterParams: {
            valueGetter: params => {
              if (this.isHauling(params.data))
                return TimesheetOperationTypeEnum.getNameFor(TimesheetOperationTypeEnum.Hauling);

              return TimesheetOperationTypeEnum.getNameFor(params.data.timesheetOperationType);
            }
          },
          width: 140,
          comparator:  (valueA, valueB) => {
            if (TimesheetOperationTypeEnum.getNameFor(valueA.timesheetOperationType) === TimesheetOperationTypeEnum.getNameFor(valueB.timesheetOperationType)) {
              return 0;
            } 
            else {
              return (TimesheetOperationTypeEnum.getNameFor(valueA.timesheetOperationType) > TimesheetOperationTypeEnum.getNameFor(valueB.timesheetOperationType)) ? 1 : -1;
            }
          },
          cellRendererFramework: Vue.extend(TimesheetOperationTypeCellRenderer),
          cellEditorFramework: Vue.extend(TimesheetOperationTypeCellEditor),
          valueGetter: (params) => {
            if (this.isHauling(params.data)) {
              return {
                timesheetOperationType: TimesheetOperationTypeEnum.Hauling
              };
            }
            const timesheetOperationType = params.data.timesheetOperationType;
            return {
              timesheetOperationType
            };
          },
          valueSetter: (params) => {
            if (params.newValue.timesheetOperationType === TimesheetOperationTypeEnum.Hauling) {
              params.data.timesheetOperationType = TimesheetOperationTypeEnum.Muck;
            }
            else {
              params.data.timesheetOperationType = params.newValue.timesheetOperationType;
            }
            return true;
          }
        },
        { 
          headerName: this.$t('GradeControl.Location.Name'),
          field: "locationCode",
          filter: true,
          filterParams: {
            valueGetter: params => {
              return params.data.locationCode
            }
          },
          width: 175,
          cellClassRules: {
            'rag-red': "(data.timesheetOperationType === 0 && ((data.locationId === null) || (typeof ctx.componentParent.locations.find(l => l.code === data.locationCode && l.type === data.locationType) === 'undefined' && typeof ctx.componentParent.locations.find(l => l.locationId === data.locationId) === 'undefined'))) || (data.timesheetOperationType === 1 && typeof ctx.componentParent.destinations.find(l => l.name === data.locationCode) === 'undefined')",
            'rag-orange': "(data.timesheetOperationType === 0 && typeof ctx.componentParent.locations.find(l => l.locationId === data.locationId) !== 'undefined') && data.locationCode !== ctx.componentParent.locations.find(l => l.locationId === data.locationId).code"
          },
          comparator:  (valueA, valueB) => {
            if (valueA.locationCode === valueB.locationCode) {
              return 0;
            } 
            else {
              return (valueA.locationCode > valueB.locationCode) ? 1 : -1;
            }
          },
          cellRendererFramework: Vue.extend(LocationCellRenderer),
          cellEditorFramework: Vue.extend(LocationCodeCellEditor),
          valueGetter: (params) => {
            const locations = this.locations;
            const locationType = params.data.locationType;
            const locationId = params.data.locationId;
            const locationCode = params.data.locationCode;
            const roundNumber = params.data.roundNumber;
            let timesheetOperationType = params.data.timesheetOperationType;
            if (this.isHauling(params.data)) {
              timesheetOperationType = TimesheetOperationTypeEnum.Hauling;
            }
            const destination = params.data.destination;
            return {
              locations,
              locationId,
              locationType,
              locationCode,
              roundNumber,
              timesheetOperationType,
              destination,
              useActualLocation: params.data.timesheetOperationType !== TimesheetOperationTypeEnum.Remuck
            };
          },
          valueSetter: (params) => {
            if (params.newValue.timesheetOperationType === TimesheetOperationTypeEnum.Muck && params.newValue.locationType !== null 
              && params.newValue.locationType !== '' 
              && params.newValue.locationCode !== null 
              && params.newValue.locationCode !== '') {
              params.data.timesheetOperationType = params.newValue.timesheetOperationType;
              params.data.locationId = params.newValue.locationId;
              params.data.locationCode = params.newValue.locationCode;
              params.data.locationType = params.newValue.locationType; 
              params.data.roundNumber = params.newValue.roundNumber;
              params.data.destination = params.newValue.destination;
              return true;
            } else if (params.newValue.timesheetOperationType === TimesheetOperationTypeEnum.Hauling && params.newValue.locationType !== null 
              && params.newValue.locationType !== '' 
              && params.newValue.locationCode !== null 
              && params.newValue.locationCode !== '') {
              params.data.timesheetOperationType = TimesheetOperationTypeEnum.Muck;
              params.data.locationId = params.newValue.locationId;
              params.data.locationCode = params.newValue.locationCode;
              params.data.locationType = params.newValue.locationType; 
              params.data.roundNumber = params.newValue.roundNumber;
              params.data.destination = params.newValue.destination;
              return true;
            } else if (params.newValue.timesheetOperationType === TimesheetOperationTypeEnum.Remuck 
              && params.newValue.locationCode !== null 
              && params.newValue.locationCode !== '' 
              && params.newValue.destination !== params.data.locationCode) {
              params.data.timesheetOperationType = params.newValue.timesheetOperationType;
              params.data.locationId = params.newValue.locationId;
              params.data.locationCode = params.newValue.locationCode;
              params.data.destination = params.newValue.destination;
              params.data.locationType = null; 
              params.data.roundNumber = null;
              return true;
            } else {
              return false;
            }
          }
        },
        {
          headerName: this.$t('GradeControl.Timesheet.Destination'),
          field: "destination",
          filter: true,
          width: 160,
          comparator:  (valueA, valueB) => {
            if (valueA.destination === valueB.destination) {
              return 0;
            } 
            else {
              return (valueA.destination > valueB.destination) ? 1 : -1;
            }
          },
          cellClassRules: {
            'rag-red': "data.timesheetOperationType ===  1 && data.destination !== null && data.destination !== '' && typeof ctx.componentParent.destinations.find(l => l.name === data.destination) === 'undefined'"
          },
          cellRendererFramework: Vue.extend(DestinationCellRenderer),
          cellEditorFramework: Vue.extend(DestinationCellEditor),
          valueGetter: (params) => {
            const destination = params.data.destination;
            const locationCode = params.data.locationCode;
            return {
              destination,
              locationCode
            };
          },
          valueSetter: (params) => {
            if (params.data.timesheetOperationType === TimesheetOperationTypeEnum.Muck) {
              params.data.destination = params.newValue.destination;
              return true;
            } else  if (params.data.timesheetOperationType === TimesheetOperationTypeEnum.Remuck
              && params.newValue.destination !== params.data.locationCode) {
              params.data.destination = params.newValue.destination;
              return true;
            } else {
              return false;
            }
          }
        },
        { 
          headerName: this.$t('GradeControl.Timesheet.MaterialType'),
          field: "materialType",
          filter: true,
          filterParams: {
            valueGetter: params => {
              return this.$t("Material." + params.data.materialType); 
            }
          },
          width: 150,
          comparator:  (valueA, valueB) => {
            if (valueA.materialType === valueB.materialType) {
              return 0;
            } 
            else {
              return (this.$t("Material." + valueA.materialType) > this.$t("Material." + valueB.materialType)) ? 1 : -1;
            }
          },
          cellRendererFramework: Vue.extend(MaterialTypeCellRenderer),
          cellEditorFramework: Vue.extend(MaterialTypeCellEditor),
          valueGetter: (params) => {
            const materialType = params.data.materialType;
            const materialSubTypeId = params.data.materialSubTypeId;
            return {
              materialType,
              materialSubTypeId
            };
          },
          valueSetter: (params) => {
            if (params.newValue.materialType !== null && params.newValue.materialType !== '') {
              params.data.materialType = params.newValue.materialType;
              params.data.materialSubTypeId = params.newValue.materialSubTypeId; 
              return true;
            } else {
              return false;
            }
          }
        }, 
        {
          headerName: this.$t('GradeControl.MuckType.Title'),
          field: "muckTypeId",
          width: 130,
          editable: true,
          filter: true,
          comparator:  (valueA, valueB) => {
            if (valueA.muckTypeId === valueB.muckTypeId) {
              return 0;
            } 
            else {
              return (valueA.muckTypeId > valueB.muckTypeId) ? 1 : -1;
            }
          },
          cellClassRules: {
            'rag-red': "data.muckTypeId == null"
          },
          cellEditorFramework: Vue.extend(MuckTypeCellEditor),
          valueGetter: (params) => {
            const muckTypeId = params.data.muckTypeId != null ? params.data.muckTypeId : null;
            const muckType = muckTypeId != null
              ? params.context.componentParent.muckTypes.find(m => m.muckTypeId === muckTypeId)
              : null;
            return {
              muckTypeId,
              muckType: muckType ? muckType.name : null
            };
          },
          valueFormatter: (params) => {
            return params.value && params.value.muckType ? params.value.muckType : '';
          },
          valueSetter: (params) => {
            params.data.muckTypeId = params.newValue && params.newValue.muckTypeId != null ? params.newValue.muckTypeId : null;
            return true;
          }
        },
        {
          headerName: this.$t('GradeControl.Equipment.Name'),
          field: "equipmentCode",
          filter: true,
          filterParams: {
            valueGetter: params => {
              return params.data.equipmentCode
            }
          },
          width: 150,
          comparator:  (valueA, valueB) => {
            if (valueA.equipmentCode === valueB.equipmentCode) {
              return 0;
            } 
            else {
              return (valueA.equipmentCode > valueB.equipmentCode) ? 1 : -1;
            }
          },
          cellClassRules: {
            'rag-red': "typeof ctx.componentParent.equipments.find(l => l.code === data.equipmentCode && l.isContractual === data.isEquipmentContractual) === 'undefined'"
          },
          cellRendererFramework: Vue.extend(EquipmentCellRenderer),
          cellEditorFramework: Vue.extend(EquipmentCodeCellEditor),
          valueGetter: (params) => {
            const isContractual = params.data.isEquipmentContractual;
            const equipmentCode = params.data.equipmentCode;
            return {
              isContractual,
              equipmentCode
            };
          },
          valueSetter: (params) => {
            if (params.newValue.equipmentCode) {
              params.data.isEquipmentContractual = params.newValue.isContractual;
              params.data.equipmentCode = params.newValue.equipmentCode; 
              return true;
            } else {
              return false;
            }
          }
        },
        {
          headerName: this.$t('GradeControl.Shift'),
          field: "shift",
          filter: true,
          width: 110,
          valueGetter: (params) => {
            return this.$t("Shift." + params.data.shift);
          },
          valueSetter: (params) => {
            if (params.newValue === this.$t("Shift." + ShiftEnum.Day) || params.newValue === this.$t("Shift." + ShiftEnum.Night)) {
              params.data.shift = params.newValue === this.$t("Shift." + ShiftEnum.Day) ? ShiftEnum.Day : ShiftEnum.Night;
              return true;
            } else {
              return false;
            }
          },
          cellEditor: 'agSelectCellEditor',
          cellEditorParams: {
            values: [this.$t("Shift." + ShiftEnum.Day), this.$t("Shift." + ShiftEnum.Night)]
          }
        },
        {
          headerName: this.$t('GradeControl.Timesheet.BlastDate'),
          field: "blastDate",
          filter: true,
          width: 150,
          valueFormatter: this.formatDateTime
        },
        {
          headerName: this.$t('GradeControl.Timesheet.BucketCount'),
          field: "bucketCount",
          hide: !this.useBucketInput(),
          filter:'agNumberColumnFilter',
          width: 130,
          cellClassRules: {
            'rag-red': "isNaN(data.bucketCount) || data.bucketCount < 0"
          },
          valueSetter: (params) => {
            if (isNaN(params.newValue))
              return false;
            
            const count = parseInt(params.newValue, 10);
            if (count < 0)
              return false;

            params.data.bucketCount = params.newValue;
            return true;
          }
        },
        {
          headerName: this.$systemUnits.getTonnageLabel(),
          field: "tonnage",
          hide: this.useBucketInput(),
          filter:'agNumberColumnFilter',
          width: 130,
          cellClassRules: {
            'rag-red': "isNaN(data.tonnage) || data.tonnage < 0"
          },
          valueFormatter: (params) => {
            if (params.value === null || isNaN(parseFloat(params.value))) return params.value;
            const value = parseFloat(params.value);
            return value % 1 === 0 || value.toFixed(2) % 1 === 0 ? value.toFixed(0) : value.toFixed(2);
          },
          valueSetter: (params) => {
            if (isNaN(params.newValue))
              return false;

            const data = parseFloat(params.newValue);
            if (data < 0 || data > 5000) // No more than 5000 tons
              return false;

            if (!params.data.equipmentCode || params.data.equipmentCode === '') {
              this.$vs.notify({
                color: "warning",
                title: this.$t("GradeControl.Timesheet.EquipmentRequired"),
                text: this.$t("GradeControl.Timesheet.EquipmentRequiredMessage")
              });
              return false;
            }

            params.data.tonnage = data;
            return true;
          }
        },
        {
          headerName: this.$t('GradeControl.Timesheet.SampleRanges'),
          field: "sampleRanges",
          filter: true,
          filterValueGetter: (params) => {
            const ranges = params.data && params.data.sampleRanges ? params.data.sampleRanges : [];
            return ranges.map(range => `${range.sampleStart}-${range.sampleEnd}`).join(", ");
          },
          width: 125,
          cellClassRules: {
            'rag-red': "isNaN(data.bucketCount) || data.bucketCount < 0"
          },
          editable: false,
          cellRendererFramework: Vue.extend(SampleRangeCellRenderer)
        },
        {
          headerName: this.$t('GradeControl.Timesheet.SampleCountShort'),
          field: "sampleCount",
          editable: false,
          filter: 'agNumberColumnFilter',
          width: 120
        },
        {
          headerName: this.$t('GradeControl.Timesheet.Employee'),
          width: 200,
          field: "employeeCode",
          filter: true,
          comparator:  (valueA, valueB) => {
            if (valueA.employeeCode === valueB.employeeCode) {
              return 0;
            } 
            else {
              return (valueA.employeeCode > valueB.employeeCode) ? 1 : -1;
            }
          },
          filterParams: {
            valueGetter: params => {
              const employee = this.context.componentParent.employees.find(l => l.code === params.data.employeeCode)
              if (employee) {
                return employee.fullName;
              }
              else {
                return "";
              }
            }
          },
          cellRendererFramework: Vue.extend(EmployeeCellRenderer),
          cellEditorFramework: Vue.extend(EmployeesCellEditor),
          valueGetter: (params) => {
            const isContractual = params.data.isEmployeeContractual;
            const employeeCode = params.data.employeeCode;
            return {
              isContractual,
              employeeCode
            };
          },
          valueSetter: (params) => {
            params.data.isEmployeeContractual = params.newValue.isContractual;
            params.data.employeeCode = params.newValue.employeeCode; 
            return true;
          }
        },
        {
          headerName: this.$t('GradeControl.Timesheet.IsAutomation'),
          field: "isAutomation",
          filter: true,
          width: 150, 
          cellRendererFramework: Vue.extend(booleanCellRenderer)
        },
        {
          headerName: this.$t('GradeControl.Timesheet.OperationComments'),
          field: "comments",
          filter: true,
          editable: false,
          width: 200
        },
        {
          headerName: this.$t('GradeControl.Timesheet.ModificationDate'),
          field: "modificationDate",
          filter: true,
          width: 150,
          valueFormatter: this.formatDateTime
        },
        {
          headerName: this.$t('GradeControl.Timesheet.ApprovalDate'),
          field: "approvalDate",
          filter: true,
          width: 150,
          valueFormatter: this.formatDateTime
        }
      ],
      components: {
        TimesheetActionsCellRenderer,
        LocationCellRenderer,
        SampleRangeCellRenderer,
        EmployeeCellRenderer,
        MaterialTypeCellRenderer,
        booleanCellRenderer
      },
      frameworkComponents: {
        LocationCodeCellEditor,
        EmployeesCellEditor,
        EquipmentCodeCellEditor,
        EquipmentCellRenderer,
        MaterialTypeCellEditor,
        MuckTypeCellEditor
      }
    };
  },

  computed: {
    equipments() {
      return this.$store.state.gradeControl.equipments;
    },
    employees() {
      return this.$store.state.gradeControl.employees;
    },
    muckTypes() {
      return this.$store.state.gradeControl.muckTypes;
    },
    muckTypeNames() {
      return this.$store.state.gradeControl.muckTypes.map(l => l.name);
    },
    materialSubTypes() {
      return this.$store.state.gradeControl.materialSubTypes;
    },
    timesheetList() {
      return this.$store.state.gradeControl.timesheets;
    },
    destinations() {
      return this.$store.state.gradeControl.destinations;
    },
    selectedDate() {
      if (this.selectedDateTime)
        return this.$options.filters.toDate(this.selectedDateTime);
      else
        return '';
    },
    timesheetSummary() {
      if (this.dailySummary !== null) {
        return [
          {
            title: this.$t('GradeControl.Timesheet.BucketCount'),
            muck: this.dailySummary.muckBucket,
            hauling: this.dailySummary.haulingBucket,
            remuck: this.dailySummary.remuckBucket,
            total: this.dailySummary.totalBucket
          },
          {
            title: this.$t('GradeControl.Timesheet.SampleCount'),
            muck: this.dailySummary.muckSample,
            hauling: this.dailySummary.haulingSample,
            remuck: this.dailySummary.remuckSample,
            total: this.dailySummary.totalSample
          },
          {
            title: this.$systemUnits.getTonnageLabel(),
            muck: this.toFriendlyTonnage(this.dailySummary.muckTonnage),
            hauling: this.toFriendlyTonnage(this.dailySummary.haulingTonnage),
            remuck: this.toFriendlyTonnage(this.dailySummary.remuckTonnage),
            total: this.toFriendlyTonnage(this.dailySummary.totalTonnage)
          }
        ];
      }
      return [];
    }
  },
  watch: {
    selectedDateTime(val) {
      if (!val) 
        return;

      const d = new Date(val);
      this.$cqrsGet("geo/gradecontrol/locations/FindByDate", { params: { projectId: this.selectedProjectId, extractionDate: d.toDateString() } })
        .then((response) => {
          this.locations = response.data.model.sort((a, b) => {
            if (a.code.toUpperCase() < b.code.toUpperCase()) return -1;
            if (a.code.toUpperCase() > b.code.toUpperCase()) return 1;
            return 0;
          });
        })
        .catch((error) => {
          console.error(error);
          this.$vs.notify({
            color: "danger",
            title: this.$t("LoadingError"),
            text: error.message
          });
        });

      this.refreshData();
    },
    showDeleted() {
      if (!this.selectedDateTime) return;
      this.refreshData();
      this.getTimesheetEntries();
    },
    versionPopupActive(val) {
      if (val === false) 
        this.versionTimesheetId = null;
    }
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.$store.dispatch("gradeControl/clearTimesheetListItems");
  },
  created() {
    if (!moduleGradeControl.isRegistered) {
      this.$store.registerModule("gradeControl", moduleGradeControl);
      moduleGradeControl.isRegistered = true;
    }

    this.selectedProjectId = Number(this.$store.state.projectId);

    this.$vs.loading();
    Promise.all([
      this.$store.dispatch("gradeControl/fetchLocationListItems", this.selectedProjectId),
      this.$store.dispatch("gradeControl/fetchEquipmentListItems", this.selectedProjectId),
      this.$store.dispatch("gradeControl/fetchEmployeeListItems", this.selectedProjectId),
      this.$store.dispatch("gradeControl/fetchMuckTypeListItems", this.selectedProjectId),
      this.$store.dispatch("gradeControl/fetchMaterialSubTypeListItems", this.selectedProjectId),
      this.$store.dispatch("gradeControl/fetchDestinationListItems", this.selectedProjectId),
      this.defineNonImportedDates()
    ]).then(() => {
      this.defineDefaultSelected()
    }).finally(() => {
      this.$vs.loading.close();
    })
  },
  methods: {
    toFriendlyTonnage(obj) {
      const copy = {};
      const keys = Object.keys(obj);
      keys.forEach(key => {
        copy[key] = this.$options.filters.toFriendlyTonnage(this.$systemUnits.convertTonnage(obj[key]));
      });
      return copy;
    },
    calculateDailySummary() {
      const d = new Date(this.selectedDateTime);
      this.$cqrsGet('geo/gradeControl/timesheet/calculateDailySummary', { params: { projectId: this.selectedProjectId, refDate: d.toDateString() } })
        .then((response) => {
          this.dailySummary = response.data.model;
        })
    },
    defineNonImportedDates() {
      return new Promise((resolve, reject) => {
        this.$webApi.get('geo/gradecontrol/TimesheetStagingEntry/GetNonImportedDates/' + this.selectedProjectId)
          .then((response) => {
            const dates = response.data.map(date => new Date(date));
            this.highlighted = { dates };
            resolve(response)
          })
          .catch((error) => {
            this._vm.$vs.notify({
              color: "danger",
              title: this.$t("LoadingError"),
              text: error.message
            });
            reject(error)
          })
      });
    },
    defineDefaultSelected() {
      return new Promise((resolve, reject) => {
        this.$webApi.get('geo/gradecontrol/Muck/GetLastImportationDate/' + this.selectedProjectId)
          .then((response) => {
            const lastDate = new Date(response.data);
            const nextDate = moment(lastDate).add(1, 'days');
            this.selectedDateTime = nextDate.toDate();
            resolve(response)
          })
          .catch((error) => {
            this._vm.$vs.notify({
              color: "danger",
              title: this.$t("LoadingError"),
              text: error.message
            });
            reject(error)
          })
      });
    },
    getMuckTypeCellEditor() {
      return {
        values : this.muckTypeNames
      }
    },
    openTimesheetReport() {
      this.$router.push({ name: "geo-gradecontrol-report-timesheet", query: { extractionDate: this.selectedDate }});
    },
    openMuckReport() {
      this.$router.push({ name: "geo-gradecontrol-report-muck", query: { extractionDate: this.selectedDate }});
    },
    createLocation() {
      this.locationPopupActive = true;
    },
    showVersion(val = false) {
      this.versionPopupActive = val;
    },
    getTimesheetEntries() {
      if (this.selectedDateTime) {
        const d = new Date(this.selectedDateTime);
        this.$store.dispatch("gradeControl/fetchTimesheetListItems",  {
          selectedDate: d.toDateString(),
          projectId: this.selectedProjectId,
          includeDeleted: this.showDeleted
        }).finally(() => {
          this.$refs.listCard.removeRefreshAnimation();
        });
      }
    },
    updateTimesheetEntry(timesheet) {
      if (timesheet) {
        this.$store.dispatch("gradeControl/updateTimesheet", timesheet).then((response) => {
          const rowNode = this.gridApi.getRowNode(response.data.timesheetStagingEntryId);
          if (rowNode) {
            rowNode.setData(response.data);
          }
        }).finally(() => {
          this.$vs.loading.close();
        });
      }
    },
    refreshTimesheets() {
      this.toggleDataSidebar(false);
    },
    refreshData() {
      this.$refs.listCard.refreshcard();
      this.calculateDailySummary();
    },
    formatDateTime(params) {
      return this.$options.filters.toDate(params.value);
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
    addNewData() {
      this.sidebarData = {};
      this.toggleDataSidebar(true);
    },
    deleteData(id) {
      this.$store.dispatch("gradeControl/removeTimesheet", id)
        .then(() => {
          this.$vs.notify({
            color: "success",
            title: this.$t("Success"),
            text: this.$t("GradeControl.Timesheet.TimesheetDeleted")
          });
          this.refreshData();
        }).catch((error) => {
          if (error.response.status === 409) {
            this.refreshData();
          }
        });
    },
    duplicateData(timesheet) {
      const clonedTimesheet = Object.assign({}, timesheet);
      clonedTimesheet.timesheetStagingEntryId = 0;
      clonedTimesheet.timesheetImportationId = null;
      clonedTimesheet.sampleStart = null;
      clonedTimesheet.sampleEnd = null;
      clonedTimesheet.sampleRanges = [];
      this.sidebarData = clonedTimesheet;
      this.toggleDataSidebar(true);
    },
    restoreData(timesheet) {
      this.$vs.loading();
      this.$webApi.post("geo/gradeControl/TimesheetStagingEntry/RestoreTimesheet/", timesheet)
        .then(() => {
          this.$vs.notify({
            title: this.$t("Success"),
            text: this.$t("GradeControl.Timesheet.RestoreCompleted"),
            color: "success",
            iconPack: 'feather',
            icon:'icon-check'
          });
          this.refreshData();
        })
        .catch((error) => {
          if (error.response.status === 409) {
            this.$vs.notify({
              color: "danger",
              title: this.$t("ConcurrencyError"),
              text: this.$t("ConcurrencyMessage")
            });
            this.refreshData();
          } else {
            this.$vs.notify({
              title: this.$t("SavingError"),
              text: error.message,
              color: "danger",
              iconPack: 'feather',
              icon:'icon-check'
            });
          }
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    openVersionPopup(timesheet) {
      this.versionTimesheetId = timesheet.timesheetStagingEntryId;
      this.showVersion(true);
    },
    openCommentsPopup(timesheet) {
      this.selectedTimesheet = timesheet;
      this.commentPopupActive = true;
    },
    cancelComments() {
      this.commentPopupActive = false;
    },
    saveComments(timesheetId, userComments) {
      const timesheet = this.$store.state.gradeControl.timesheets.find(t => t.timesheetStagingEntryId === timesheetId);
      if (timesheet !== undefined) {
        timesheet.userComments = userComments;
        this.updateTimesheetEntry(timesheet)
      }
    
      this.commentPopupActive = false;
    },

    timesheetUpdated(timesheet) {
      this.$vs.notify({
        title: this.$t("Success"),
        text: this.$t("SaveSuccess"),
        color: "success",
        iconPack: 'feather',
        icon:'icon-check'
      });

      this.toggleDataSidebar(false);

      const date1 = new Date(this.selectedDateTime);
      const date2 = new Date(timesheet.extractionDate)

      if (date1.Date === date2.Date) {
        const rowNode = this.gridApi.getRowNode(timesheet.timesheetStagingEntryId);
        if (rowNode) {
          rowNode.setData(timesheet);
        }

        this.gridApi.applyTransaction({ update: [timesheet] });
      }
    },

    timesheetInserted(timesheet) {
      this.$vs.notify({
        title: this.$t("Success"),
        text: this.$t("InsertSuccess"),
        color: "success",
        iconPack: 'feather',
        icon:'icon-check'
      });
      this.toggleDataSidebar(false);
      this.gridApi.applyTransaction({ update: [timesheet] });
    },

    editData(data) {
      this.sidebarData = data;
      this.toggleDataSidebar(true);
    },
    openImportConfirm() {
      const rows = this.gridApi.getSelectedRows();
      if (rows.length === 0) {
        this.$vs.dialog({
          color: 'danger',
          title: this.$t("Import"),
          text: this.$t('GradeControl.Timesheet.NoTimesheetSelected')
        })
      }
      else {
        this.$vs.dialog({
          type: "confirm",
          color: "warning",
          title: this.$t("Import"),
          text: this.$t('GradeControl.Timesheet.ConfirmImport'),
          accept: this.sampleCountWarning
        });
      }
    },

    sampleCountWarning() {

      const rows = this.gridApi.getSelectedRows();
      let tooManySamples = false;
      rows.forEach(row => {
        if (row.sampleCount >= 50)
          tooManySamples = true;
      });

      if (tooManySamples) {
        this.$vs.dialog({
          type: "confirm",
          color: "warning",
          title: this.$t("Import"),
          text: this.$t('GradeControl.Timesheet.TooManySample'),
          accept: this.import
        });

      } else {
        this.import();
      }
    },

    import() {
      const rows = this.gridApi.getSelectedRows();

      this.$vs.loading();
      this.$webApi.post('geo/gradecontrol/TimesheetImportation/', {
        timesheetsId: rows.map(l => l.timesheetStagingEntryId),
        projectId: this.selectedProjectId
      }).then((result) => {

        if (result.data.isSuccess) {
          this.$vs.notify({
            title: this.$t("Import"),
            text: this.$t("GradeControl.Timesheet.ImportCompleted"),
            color: "success",
            iconPack: 'feather',
            icon:'icon-check'
          });
        }
        else {
          this.importationPopupActive = true;
          this.importationResults = result.data.results;
        }

        this.refreshData();

      
      }).finally(() => {
        this.$vs.loading.close();
      });
    },
    locationInserted(location) {
      this.$vs.notify({
        title: this.$t("Success"),
        text: this.$t("InsertSuccess"),
        color: "success",
        iconPack: 'feather',
        icon:'icon-check'
      });
      this.locationPopupActive = false;
      this.newLocationCode = location.code;
    },
    locationCancelled() {
      this.locationPopupActive = false;
    },
    versionClosed() {
      this.versionTimesheetId = null;
      this.versionPopupActive = false;
    },
    openDeleteConfirm() {
      const rows = this.gridApi.getSelectedRows();
      if (rows.length === 0) {
        this.$vs.dialog({
          color: 'danger',
          title: this.$t("Delete"),
          text: this.$t('GradeControl.Timesheet.NoTimesheetSelected')
        })
      }
      else {
        this.$vs.dialog({
          type: "confirm",
          color: "warning",
          title: this.$t("Delete"),
          text: this.$t('GradeControl.Timesheet.ConfirmDeleteMultiple'),
          accept: this.deleteBatch
        });
      }
    },
    deleteBatch() {
      const rows = this.gridApi.getSelectedRows();
      this.$vs.loading();


      this.$store.dispatch("gradeControl/removeTimesheetBatch", rows.map(t => t.timesheetStagingEntryId))
        .then(() => {
          this.$vs.notify({
            color: "success",
            title: this.$t("Success"),
            text: this.$t("GradeControl.Timesheet.TimesheetDeleted")
          });

          this.refreshData();
         
        }).finally(() => {
          this.$vs.loading.close();
        });    
    },
    openCancelImportConfirm() {
      const rows = this.gridApi.getSelectedRows();
      if (rows.length === 0) {
        this.$vs.dialog({
          color: 'danger',
          title: this.$t("Import"),
          text: this.$t('GradeControl.Timesheet.NoTimesheetSelected')
        })
      }
      else {
        this.$vs.dialog({
          type: "confirm",
          color: "warning",
          title: this.$t("Import"),
          text: this.$t('GradeControl.Timesheet.ConfirmCancelImportBatch'),
          accept: this.cancelImportBatch
        });
      }
    },

    cancelImportBatch() {
      const rows = this.gridApi.getSelectedRows();
      this.$vs.loading();
      this.$webApi.post('geo/gradecontrol/TimesheetImportation/CancelImportation/', {
        timesheetsId: rows.map(l => l.timesheetStagingEntryId)
      }).then(() => {

        this.$vs.notify({
          title: this.$t("Import"),
          text: this.$t("GradeControl.Timesheet.CancelImportCompletedBatch"),
          color: "success",
          iconPack: 'feather',
          icon:'icon-check'
        });
  
        this.refreshData();
      
      }).catch((error) => {
        if (error.response.status === 409) {
          this.$vs.notify({
            color: "danger",
            title: this.$t("ConcurrencyError"),
            text: this.$t("ConcurrencyMessage")
          });
          this.refreshData();
        } else {
          this.$vs.notify({
            title: this.$t("SavingError"),
            text: error.message,
            color: "danger",
            iconPack: 'feather',
            icon:'icon-check'
          });
        }
      }).finally(() => {
        this.$vs.loading.close();
      });
    },
    cancelImportation(timesheet) {
      this.$vs.loading();
      this.$webApi.post('geo/gradecontrol/TimesheetImportation/CancelImportation/', {
        timesheetsId: [timesheet.timesheetStagingEntryId]
      }).then(() => {

        this.$vs.notify({
          title: this.$t("Import"),
          text: this.$t("GradeControl.Timesheet.CancelImportCompleted"),
          color: "success",
          iconPack: 'feather',
          icon:'icon-check'
        });
  
        this.refreshData();
      
      }).catch((error) => {
        if (error.response.status === 409) {
          this.$vs.notify({
            color: "danger",
            title: this.$t("ConcurrencyError"),
            text: this.$t("ConcurrencyMessage")
          });
          this.refreshData();
        } else {
          this.$vs.notify({
            title: this.$t("SavingError"),
            text: error.message,
            color: "danger",
            iconPack: 'feather',
            icon:'icon-check'
          });
        }
      }).finally(() => {
        this.$vs.loading.close();
      });
    },
    useBucketInput() {
      return this.$store.getters.isProjectUsingBucketInput;
    },
    isHauling(timesheet) {
      const equipment = this.$store.state.gradeControl.equipments.find(l => l.code === timesheet.equipmentCode && l.isContractual === timesheet.isEquipmentContractual);
      return equipment !== undefined && equipment.type === EquipmentTypeEnum.Truck && timesheet.timesheetOperationType === TimesheetOperationTypeEnum.Muck;
    }
  }
};
</script>
<style lang="scss">
#timesheet-view {
  .timesheet-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
.timesheet-modified {
  border-width: 1 !important;
  border-style: solid !important;
  border-color:  #ffcc00 !important;
}

.timesheet-approved {
  border-width: 1 !important;
  border-style: solid !important;
  border-color:  #339900 !important;
}

.timesheet-deleted {
  border-width: 1 !important;
  border-style: solid !important;
  border-color:  #E57373 !important;
}

.rag-red {
  background-color: #FFEBEE;
  border-color: #E57373 !important;
  border-width: 1 !important;
  border-style: solid !important;
}

.rag-orange {
  background-color: #fff1ba;
  border-color: #ffcc00 !important;
  border-width: 1 !important;
  border-style: solid !important;
}

.con-vs-popup .vs-popup {
    width: auto !important;
}

.vs__actions {
  z-index: 2;
}

.summaryTable {
  width: 100%;
}
</style>